const configurationClient = [
    '23011'
]
export {
    configurationClient
}